
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { AppointmentFormData, AppointmentResult } from "./types";

export async function updateAppointment(appointmentData: AppointmentFormData): Promise<AppointmentResult> {
  try {
    console.log("Iniciando atualização do compromisso:", appointmentData);
    
    if (!appointmentData.id) {
      console.error("ID do compromisso não fornecido");
      return { 
        success: false, 
        error: { message: "ID do compromisso não fornecido" } 
      };
    }
    
    const { data, error } = await supabase
      .from("appointments")
      .update({
        title: appointmentData.title,
        type: appointmentData.type,
        date: appointmentData.date.toISOString(),
        end_date: appointmentData.end_date?.toISOString(),
        location: appointmentData.location,
        notes: appointmentData.notes,
        client_id: appointmentData.client_id,
        updated_at: new Date().toISOString(),
      })
      .eq("id", appointmentData.id)
      .select();

    if (error) {
      console.error("Erro ao atualizar compromisso:", error);
      toast({
        title: "Erro ao atualizar compromisso",
        description: error.message,
        variant: "destructive",
      });
      return { success: false, error };
    }

    console.log("Compromisso atualizado com sucesso:", data);
    toast({
      title: "Compromisso atualizado com sucesso!",
      description: "As informações do compromisso foram atualizadas.",
    });
    return { success: true, data };
  } catch (error: any) {
    console.error("Exceção ao atualizar compromisso:", error);
    toast({
      title: "Erro ao atualizar compromisso",
      description: error.message,
      variant: "destructive",
    });
    return { success: false, error };
  }
}
